import { AuthMailInfo } from '../../models/auth-mail/auth-mail-info';

/**
 * 認証メール送信リクエスト
 */
export class SendAuthMailRequest {
	public authMailInfo: AuthMailInfo = null; // 認証メール情報
}